<template>
  <div id="app">
    <div class="mx-auto" style="width: 500px;">
      <b-list-group>
        <b-list-group-item class="bg-light">Boucle externe</b-list-group-item>
        <!-- <b-list-group-item>
          <b-badge variant="info">27 andons actifs</b-badge> sur
          <b-badge variant="info">345 andons stoppés</b-badge>
        </b-list-group-item>
        <b-list-group-item>
          Temps moyen d'arrêt: <b-badge variant="danger">420 minutes</b-badge>
        </b-list-group-item> -->
        <b-list-group-item>
          Temps boucle complète moyen: <b-badge variant="info">13 jours</b-badge>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col>Nombre de tours moyens:</b-col><b-col><b-badge variant="info">27</b-badge></b-col>
            </b-row>
            <b-row>
                <b-col>Nombre de tours aujourd'hui:</b-col><b-col><b-badge variant="info">24</b-badge></b-col>
            </b-row>
            <b-row>
                <b-col>OEE:</b-col><b-col><b-badge variant="info">88 %</b-badge></b-col>
            </b-row>

        </b-list-group-item>
      </b-list-group>
    </div>
    <div id="hyppo" class="mx-auto">
      <div id="hyppo-background"></div>
      <div id="stock">
        <div class="dot danger"
        v-b-popover.hover.top="'7 andons'">
            <p>{{steps['En Stock'].display}}</p>
        </div>
      </div>
      <div id="attCommande">
        <div class="dot success"
        v-b-popover.hover.top="'0 andons'">
            <p>{{steps['Attente commande'].display}}</p>
        </div>
      </div>
      <div id="commande">
        <div class="dot danger"
        v-b-popover.hover.top="'20 andons'">
            <p>{{steps['Commandé'].display}}</p>
        </div>
      </div>
      <link-info
        :info="'12 J'"
        class="link-from"
        id="link-from-cmd-to-stock"
      />
      <link-info
        :info="'13 J'"
        class="link-from"
        id="link-from-stock-to-att-cmd"
      />
      <link-info
        :info="'0.8 J'"
        class="link-from"
        id="link-from-att-cmd-to-cmd"
      />
    </div>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import { Steps } from '../../core/services/steps.js'
import { Utils } from '../../core/utils/utils.js'
import LinkInfo from '../andon/detailed/LinkInfo.vue'
import moment from 'moment'

export default {
  name: 'AndonReference',
  props: [],
  data () {
    return {
        steps: JSON.parse(JSON.stringify(Steps)),
        items: [
          { loop: 'Externe', andon: 27, stop: true, start_again: '4 min' },
          { loop: 'Interne', andon: 3, stop: false, start_again: 'En marche' }
        ],
        fields: [
        // { key: 'loops'},
        { key: 'loop', label: 'Boucle', sortable: true },
        { key: 'Andon', label: 'A un andon'},
        { key: 'Arrêt', label: 'Boucle stoppée'},
        { key: 'start_again', label: 'Reprise dans', sortable: true }
      ]
    }
  },
  methods: {
    displayDelay (since) {
      var now = moment()
      return now.diff(moment(since), 'days')
    },
    displayRef (reference) {
      return this.chunk(reference, 3).join(' ')
    },
  },
  mounted: function () {},
  components: { LinkInfo }
// eslint-disable-next-line
};
</script>

<style type="text/css" scoped>
.andon-board {
    height: 7vh;
    color: white;
    line-height: 7vh;
}
#hyppo {
  position: relative;
  background-image: url('../../assets/hyppo-back.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 1023px;
  height: 782px;
}

.andon-spot {
    height: 4vh;
    width: 4vh;
    text-align: center;
    margin-left: 45%;
}
.dot {
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: inline-block;
  color: white;
}

.info {
    border: solid;
    background-color: lightgrey;
}

.warning {
    background-color: #f0ad4e;
}

.danger {
    background-color: #d9534f;
}
.success {
    background-color: #5cb85c;
}
.dot .badge {
  padding-top: 10px;
  font-size: 1.2em;
}
.dot p {
  padding-top: 40px;
  font-size: 1.2em;
  font-weight: bold;
}
#commande {
  height: 12vh;
  width: 12vh;
  position: absolute;
  top: 35px;
  left: 480px;
}
#stock {
  height: 12vh;
  width: 12vh;
  position: absolute;
  top: 485px;
  left: 250px;
}
#attCommande {
  height: 12vh;
  width: 12vh;
  position: absolute;
  top: 35px;
  left: 170px;
}
#link-from-att-cmd-to-cmd {
  position: absolute;
  top: 9.5%;
  left: 32%;
}
#link-from-cmd-to-stock {
  position: absolute;
  top: 37%;
  left: 86%;
}
#link-from-stock-to-att-cmd {
  position: absolute;
  top: 37%;
  left: 3%;
}
</style>
<style type="text/css">
.link-from span
{
  background-color: rgb(139, 150, 173) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/supply/ExternalLoopGeneralOverview.vue